import React from "react";
import { Button, Menu, Text } from "@mantine/core";
import { FileExport, Qrcode } from "tabler-icons-react";

interface BulkActionsMenuProps {
  onBulkQRDownload: () => void;
  onCreateFlexOptionsSet: () => void;
  loading: boolean;
}

export function BulkActionsMenu({ onBulkQRDownload, onCreateFlexOptionsSet, loading }: BulkActionsMenuProps) {
  return (
    <Menu
      size="lg"
      styles={{
        item: {
          minHeight: 44,
          padding: "10px 16px",
        },
      }}
      control={<Button color="cap-blue" variant="outline" size="sm" leftIcon={<FileExport size={16} />}>Actions</Button>}
    >
      <Menu.Item onClick={onBulkQRDownload}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Qrcode color="gray" />
          <Text ml="sm" size="sm">Download QR codes</Text>
        </div>
      </Menu.Item>
      <Menu.Item onClick={onCreateFlexOptionsSet} disabled={loading}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img src="/captiva-flex.png" alt="Flex Options" style={{ width: 24 }} />
          <Text ml="sm" size="sm">{loading ? 'Creating Flex Options...' : 'Export as Flex Options set'}</Text>
        </div>
      </Menu.Item>
    </Menu>
  );
}